const locale = {
  id: 'ClassroomConstant',
  code: 'CN',
  text: {
    "./images/classroom_en@2x.png": "./images/Classroom@2x.png",
    'Personalized Classroom Management': '个性化的教室',
    'Effective Classroom Management allows you to manage your school for efficiently. Depends on the purpose, you can create a classroom for different events as well.': '有效的教室管理可以节省不必要的资源浪费。根据不同的用途，定制个性化的教室/场地名称。也可以在课表里根据教室来筛选课程。',
  }
}

export const onBoardingContents = {
  title: __('Personalized Classroom Management', locale),
  text: __('Effective Classroom Management allows you to manage your school for efficiently. Depends on the purpose, you can create a classroom for different events as well.', locale),
  image: require(__('./images/classroom_en@2x.png', locale)),
  showArrow: true,
}



// WEBPACK FOOTER //
// ./src/containers/pages/Classroom/constant.js